/** Build expanded state with all parent rows (those with children) expanded. */
export function getDefaultExpandedState<
    T extends { id: string; children?: unknown[] },
>(rows: T[]): Record<string, boolean> {
    const state: Record<string, boolean> = {};
    for (const row of rows) {
        if (row.children && row.children.length > 0) {
            state[row.id] = true;
        }
    }
    return state;
}
